import merge from 'lodash.merge';
import constants from '../../constants';

const defaultLocalization = { pagination: { labelRowsPerPage: '', }, header: { actions: '' }, };

export function getLocalization(localization = {}, locale, formatMessage) {
  if (locale === constants.locales.enEN) {
    return merge({}, defaultLocalization, localization);
  }
  const defaultLocalization2 = merge({}, defaultLocalization, {
    body: {
      emptyDataSourceMessage: formatMessage({ id: 'TABLE_BODY_EMPTY_DATA_SOURCE_MESSAGE' }),
      addTooltip: formatMessage({ id: 'TABLE_BODY_ADD_TOOLTIP' }),
      deleteTooltip: formatMessage({ id: 'TABLE_BODY_DELETE_TOOLTIP' }),
      editTooltip: formatMessage({ id: 'TABLE_BODY_EDIT_TOOLTIP' }),
      filterRow: {
        filterTooltip: formatMessage({ id: 'TABLE_BODY_FILTER_ROW_FILTER_TOOLTIP' }),
      },
      editRow: {
        deleteText: formatMessage({ id: 'TABLE_BODY_EDIT_ROW_DELETE_TEXT' }),
        cancelTooltip: formatMessage({ id: 'TABLE_BODY_EDIT_ROW_CANCEL_TOOLTIP' }),
        saveTooltip: formatMessage({ id: 'TABLE_BODY_EDIT_ROW_SAVE_TOOLTIP' }),
      }
    },
    grouping: {
      placeholder: formatMessage({ id: 'TABLE_GROUPING_PLACEHOLDER' }),
    },
    pagination: {
      labelDisplayedRows: formatMessage({ id: 'TABLE_PAGINATION_LABEL_DISPLAYED_ROWS' }),
      labelRowsSelect: formatMessage({ id: 'TABLE_PAGINATION_LABEL_ROWS_SELECT' }),
      firstAriaLabel: formatMessage({ id: 'TABLE_PAGINATION_FIRST_ARIA_LABEL' }),
      firstTooltip: formatMessage({ id: 'TABLE_PAGINATION_FIRST_TOOLTIP' }),
      previousAriaLabel: formatMessage({ id: 'TABLE_PAGINATION_PREVIOUS_ARIA_LABEL' }),
      previousTooltip: formatMessage({ id: 'TABLE_PAGINATION_PREVIOUS_TOOLTIP' }),
      nextAriaLabel: formatMessage({ id: 'TABLE_PAGINATION_NEXT_ARIA_LABEL' }),
      nextTooltip: formatMessage({ id: 'TABLE_PAGINATION_NEXT_TOOLTIP' }),
      lastAriaLabel: formatMessage({ id: 'TABLE_PAGINATION_LAST_ARIA_LABEL' }),
      lastTooltip: formatMessage({ id: 'TABLE_PAGINATION_LAST_TOOLTIP' }),
    },
    toolbar: {
      addRemoveColumns: formatMessage({ id: 'TABLE_TOOLBAR_ADD_REMOVE_COLUMNS' }),
      nRowsSelected: formatMessage({ id: 'TABLE_TOOLBAR_N_ROWS_SELECTED' }),
      showColumnsTitle: formatMessage({ id: 'TABLE_TOOLBAR_SHOW_COLUMNS_TITLE' }),
      showColumnsAriaLabel: formatMessage({ id: 'TABLE_TOOLBAR_SHOW_COLUMNS_ARIA_LABEL' }),
      exportTitle: formatMessage({ id: 'TABLE_TOOLBAR_EXPORT_TITLE' }),
      exportAriaLabel: formatMessage({ id: 'TABLE_TOOLBAR_EXPORT_ARIA_LABEL' }),
      exportName: formatMessage({ id: 'TABLE_TOOLBAR_EXPORT_NAME' }),
      searchTooltip: formatMessage({ id: 'TABLE_TOOLBAR_SEARCH_TOOLTIP' }),
      searchPlaceholder: formatMessage({ id: 'TABLE_TOOLBAR_SEARCH_PLACEHOLDER' }),
    },
  });
  return merge({}, defaultLocalization2, localization);
}